<!-- 服务商城轮播图 -->

<template>
  <div class="carousel" v-loading="loading">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-input class="s_input" v-model="titleValue" placeholder="搜索标题名称" suffix-icon="el-icon-search"
        @change="onSearch" clearable></el-input>
      <el-button class="btn" type="primary" @click="handleAdd(1)">新增</el-button>
    </div>
    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" prop="title" label="标题" show-overflow-tooltip></el-table-column>
        <el-table-column min-width="120" prop="content" label="内容" show-overflow-tooltip></el-table-column>
        <el-table-column min-width="120" prop="contentUrl" label="图片" align="center">
          <template slot-scope="scope">
            <el-image style="width: 180px; height: 69px" :src="scope.row.contentUrl" fit="cover"
              @click="previewImage(scope.row.contentUrl)"></el-image>
          </template>
        </el-table-column>
        <el-table-column min-width="120" prop="linkUrl" label="链接" align="center"
          show-overflow-tooltip></el-table-column>
        <el-table-column min-width="120" prop="sortNum" label="排序"></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="200"
          min-width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="handleEdit(scope.row, 2)">修改</el-button>
            <el-button type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 添加 / 修改 -->
      <el-dialog :title="titles" :visible.sync="dialogVisible" :before-close="onCancel">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="图片上传" prop="fileUrl">
                <el-upload v-model="ruleForm.fileUrl" ref="upload" :action="apiBaseUrl" name="multipartFile"
                  :headers="apiHeaders" :limit="1" :file-list="importFiles" accept=".jpg,.png"
                  :on-success="handleSuccess" :before-upload="beforeUpload">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="标题" prop="title">
                <el-input v-model="ruleForm.title" placeholder="请输入标题"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="显示顺序" prop="sortNum">
                <el-input v-model="ruleForm.sortNum" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="链接" prop="linkUrl">
                <el-input v-model="ruleForm.linkUrl" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="内容" prop="content">
                <el-input type="textarea" placeholder="请输入内容" v-model="ruleForm.content" maxlength="100"
                  show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-image-viewer v-if="showViewer" :on-close="() => {
      showViewer = false
    }
      " :url-list="imgList"></el-image-viewer>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      loading: false,
      titleValue: "", // 搜索标题
      // 表格数据
      tableData: [],

      titles: "",
      dialogVisible: false,
      apiBaseUrl: this.$axios.defaults.baseURL + this.$api.uploadFile,
      apiHeaders: {
        token: this.$store.state.token,
      },
      importFiles: [],
      ruleForm: {
        title: "",
        sortNum: "",
        linkUrl: "",
        content: "",
        fileUrl: "",
      },
      rules: {
        fileUrl: [
          {
            required: true,
            message: "请上传",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        linkUrl: [
          {
            required: true,
            message: "请输入链接",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
        sortNum: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
          {
            validator: function (rule, value, callback) {
              if (/^[1-9]\d*$/.test(value) == false) {
                callback(new Error("请输入整数"))
              } else {
                //校验通过
                callback()
              }
            },
            trigger: "blur",
          },
        ],
      },
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      // 图片预览
      showViewer: false,
      imgList: [],
      shopId: "",
      index: "",
    }
  },
  created() {
    this.getCarouselList()
  },
  methods: {
    // 获取列表
    getCarouselList() {
      this.loading = true
      this.$axios
        .get(this.$api.getCarouselList, {
          params: {
            titleName: this.titleValue || null, // 标题
            bizType: 1, // 业务类型：1服务商城；2购物商城
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    handleSuccess(res) {
      if (res.code == 100) {
        this.$message.success(res.desc)
        this.ruleForm.fileId = res.result.fileId
        this.ruleForm.fileUrl = res.result.fileUrl
      } else {
        this.$message.error(res.desc)
        this.importFiles = []
      }
    },
    beforeUpload(file) {
      // console.log(file);
      const suffixArr = ["jpg", "png"]
      if (!suffixArr.includes(file.name.split(".").pop())) {
        this.$message.error(`只能上传"jpg""png"格式图片`)
        return false
      }
    },
    // 打开对话框
    handleAdd(e) {
      this.titles = "新增"
      this.index = e
      this.dialogVisible = true
    },
    // 关闭对话框
    onCancel() {
      this.resetForm()
      this.dialogVisible = false
    },
    // 重置表单
    resetForm() {
      this.ruleForm = {}
      this.$refs.upload.clearFiles()
      this.$refs.ruleForm.resetFields()
      this.ruleForm.fileUrl = ""
      this.importFiles = []
    },
    // 提交表单
    submitForm(formName) {
      let param = {
        bizType: 1, // 业务类型 1服务商城；2购物商城
        contentType: 1, // 内容类型：1图片；2视频
        title: this.ruleForm.title,
        sortNum: this.ruleForm.sortNum,
        linkUrl: this.ruleForm.linkUrl,
        content: this.ruleForm.content,
        contentUrl: this.ruleForm.fileUrl,
        id: this.id,
      }
      if (this.index == 1) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$axios
              .post(this.$api.saveCarouselList, param)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success("新增成功")
                  //提交成功后，清空上传图片的路径
                  this.resetForm()
                  this.importFiles = []
                  this.dialogVisible = false
                  this.getCarouselList()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          } else {
            this.$message.error("新增失败")
            return false
          }
        })
      } else {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$axios
              .post(this.$api.updateCarouselList, param)
              .then(res => {
                if (res.code == 100) {
                  this.$message.success("修改成功")
                  this.resetForm()
                  this.dialogVisible = false
                  this.getCarouselList()
                }
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          } else {
            this.$message.error("修改失败")
            return false
          }
        })
      }
    },
    // 编辑
    handleEdit(row, e) {
      this.dialogVisible = true
      let data = Object.assign({}, row)
      this.titles = "编辑"
      this.index = e
      this.ruleForm = data
      this.id = data.id
      this.ruleForm.fileUrl = data.contentUrl
      this.importFiles = [
        {
          url: data.contentUrl,
          name: data.contentUrl,
        },
      ]
    },

    // 删除
    handleDelete(row) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.$axios
          .post(this.$api.deleteCarouselList, {
            id: row.id,
            bizType: 1,
          })
          .then(res => {
            if (res.code == 100) {
              this.$message.success("删除成功!")
            }
            this.getCarouselList()
          })
          .catch(err => {
            this.$message.error(err.desc)
          })
      })
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 搜索
    onSearch() {
      this.clearData()
      this.getCarouselList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.pageSize = e
      this.onSearch()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getCarouselList()
    },
    // 图片预览
    previewImage(url) {
      this.imgList[0] = url
      this.showViewer = true
    },
  },
}
</script>

<style lang="scss" scoped>
.carousel {

  // 内容
  ::v-deep .el-textarea__inner {
    resize: none;
    border-radius: 10px;
    height: 172px;
  }
}
</style>
